import React from 'react';
import { Listbox, Transition } from '@headlessui/react';
import ValidationWrapper from '../validation/ValidationWrapper';
import { getText } from '../../utils/functions';
import { useIcons } from '../../utils/hooks';


/* THIS COMPONENT LACKS LABEL, IT ONLY IMPLEMENTS THE **INPUT**  */

/* --------------------DEFAULT ITEMS-------------------- */
const defaultClassNameBTN = {
	button: 'w-full pb-1 flex justify-between items-center focus:outline-none',
	input: 'w-full focus:outline-none cursor-pointer',
	imgCollapsed: 'transform h-2',
	imgOpen: 'transform h-2 rotate-180',
};
const defaultTransition = {
	enter: 'transition duration-1000 ease-in-out',
	enterFrom: 'transform opacity-0',
	enterTo: 'transform opacity-100',
	leave: 'transition duration-600 ease-in-out',
	leaveFrom: 'transform opacity-100',
	leaveTo: 'transform opacity-0',
};
const defaultClassNameITEM = {
	div: 'w-full flex p-2 space-x-2 italic cursor-pointer',
	divActive: '',
	divSelected: 'font-bold',
	img: 'hidden',
	imgSelected: '',
	span: '',
};
/* --------------------DEFAULT ITEMS-------------------- */

/*
* Main function
*/
function SelectInput({
	name,
	value = '',
	onChange = () => { },
	items = [],
	colors,
	required,
	checkbbdd,
	translate,
	itemIcon,

	/* OPTIONAL PROPS */
	portal,
	id,
	confirmValue,
	confirmError,
	// placeholder = 'Selecciona una de las opciones',
	classNameDIV = 'w-full relative mt-1',
	styleDIV,
	classNameBTN,
	classNameITEMLIST = 'w-full z-40 relative max-h-60',
	transition,
	classNameOPTS = 'absolute top-3 w-full py-2 max-h-48 overflow-y-scroll flex flex-col space-y-2 rounded-sm',
	styleOPTS,
}) {
	/* Variables that keeps track of the selected item */
	const [selectedItem, setSelectedItem] = React.useState();

	/* Icon hook */
	const { ArrowDown } = useIcons(colors);

	React.useEffect(() => {
		setSelectedItem(items.find(element => element.value === value));
	}, [value]);

	/* Default values for the styles */
	const defaultStyleDIV = {
		color: colors?.text,
	};
	const styleBTN = {
	};
	const defaultStyleOPTS = {
		backgroundColor: colors?.background,
		border: `1px solid ${colors?.primary}`,
	};

	/* This allows for only one of the fields to be modified and still keep the other constant values */
	const overrideClassNameBTN = { ...defaultClassNameBTN, ...classNameBTN };
	const overrideTransition = { ...defaultTransition, ...transition };
	const overrideStyleDIV = { ...defaultStyleDIV, ...styleDIV };
	const overrideStyleOPTS = { ...defaultStyleOPTS, ...styleOPTS };

	return <Listbox
		id={id}
		value={value}
		onChange={onChange}
	>
		{({ open }) => <ValidationWrapper
			value={value}
			name={name}
			required={required}
			checkbbdd={checkbbdd}
			colors={colors}
			event={open}
			confirmValue={confirmValue}
			confirmError={confirmError}
		>
			<div
				className={classNameDIV}
				style={overrideStyleDIV}
			>
				<Listbox.Button
					className={overrideClassNameBTN.button}
					style={styleBTN}
				>
					<input
						readOnly
						style={{ backgroundColor: colors?.background }}
						placeholder={getText(portal?.config?.forms?.initialStatePlaceholder, translate)}
						className={overrideClassNameBTN.input}
						value={getText(selectedItem, translate) || ''}
					/>
					{ArrowDown && ArrowDown({
						className: `${open ? overrideClassNameBTN.imgOpen : overrideClassNameBTN.imgCollapsed}`
					})}
				</Listbox.Button>
				<div className={classNameITEMLIST}>
					<Transition
						enter={overrideTransition.enter}
						enterFrom={overrideTransition.enterFrom}
						enterTo={overrideTransition.enterTo}
						leave={overrideTransition.leave}
						leaveFrom={overrideTransition.leaveFrom}
						leaveTo={overrideTransition.leaveTo}
					>
						<Listbox.Options className={classNameOPTS} style={overrideStyleOPTS}>
							{items.map(option => (
								<Listbox.Option
									key={option.value}
									value={option.value}
								>
									{({ active, selected }) => (
										<SelectListItem
											option={option}
											active={active}
											selected={selected}
											colors={colors}
											itemIcon={itemIcon}
											translate={translate}
										/>
									)}
								</Listbox.Option>
							))}
						</Listbox.Options>
					</Transition>
				</div>
			</div>
		</ValidationWrapper>}
	</Listbox>;
}

/*
* The select list items
*/
function SelectListItem({
	option,
	active,
	selected,
	colors,
	translate,
	itemIcon,
	classNameITEM,
	styleITEM,
}) {
	/* Variables that checks if any point the components are focused or selected */
	const [focusITEM, setFocusITEM] = React.useState(false);

	/* Default values for the styles */
	const defaultStyleITEM = {
		backgroundColor: focusITEM ? colors?.light : colors?.background
	};

	/* This allows for only one of the fields to be modified and still keep the other constant values */
	const overrideClassNameITEM = { ...defaultClassNameITEM, ...classNameITEM };
	const overrideStyleITEM = { ...defaultStyleITEM, ...styleITEM };

	/* Handle on focusITEM */
	const onMouseOverITEM = () => setFocusITEM(true);

	/* Handle on loose focuseITEM */
	const onMouseLeaveITEM = () => setFocusITEM(false);

	return <div
		className={`${overrideClassNameITEM.div} ${active && overrideClassNameITEM.divActive} ${selected && overrideClassNameITEM.divSelected}`}
		style={overrideStyleITEM}
		onMouseOver={onMouseOverITEM}
		onMouseLeave={onMouseLeaveITEM}
	>
		<img className={`${overrideClassNameITEM.img} ${active && overrideClassNameITEM.imgSelected}`} src={itemIcon} />
		<span className={overrideClassNameITEM.span}>
			{getText(option, translate)}
		</span>
	</div>;
}

export default SelectInput;
